export default __webpack_public_path__ + "static/img_15-335fe1d2ed8c59c63ebc009106285a34.png";